var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.333h512V426.67H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 255.996h211.478v85.337H0zm300.522 0H512v85.337H300.522z",
  fill: "#6da544"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.33v85.332h211.478V85.333h89.044v85.329H512V85.33z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M300.522 170.659H512v85.337H300.522zM0 170.659h211.478v85.337H0z",
  fill: "#f0f0f0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M300.522 426.659h-89.044V341.33H0v85.332h512V341.33H300.522zM119.678 111.3l4.604 14.172h14.902l-12.054 8.759 4.604 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.055-8.759h14.9z",
  fill: "#ffda44"
})));

export default SvgCf;